export default __webpack_public_path__ + "static/media/screen7.005dec76.png";